module.exports = __webpack_public_path__ + "static/media/cotiza-cajas-02.588742a4.svg";